import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { INVENTORY_ENDPOINT } from "./constants";
import useFetchWithAuth from "../fetchWithAuth";

type Result = Partial<{
  success: boolean;
  statusCode: number;
  response: {
    count: number;
    rating: string;
    trip_id: number;
  };
}>;
type QueryError = {};

const useTripReviewsSummaryQuery = (
  tripId: number,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const url = `${INVENTORY_ENDPOINT}/trips/${tripId}/reviews/summary`;
  const cacheKey = [url];
  const { fetchWithAuth } = useFetchWithAuth();

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!tripId) throw new Error();
      return fetchWithAuth<Result>(url);
    },
    {
      ...options,
      enabled: !!tripId,
    }
  );
};
export default useTripReviewsSummaryQuery;
